

// /* eslint-disable no-unused-vars */
// import React, { useEffect, useState } from "react";
// import "./Promises.css";
// import { useParams } from "react-router-dom";
// import { useDispatch, useSelector } from "react-redux";
// import { fetchAllLoans } from "../../redux/slices/loan/loanReportSlice";
// import { fetchCustomers } from "../../redux/slices/Customer/customerReportSlice";
// import { toast } from "react-toastify";
// import jsPDF from "jspdf";
// import html2canvas from "html2canvas";

// const Promises = () => {
//   const { loanId } = useParams();
//   const dispatch = useDispatch();
//   const superAdminId = Number(localStorage.getItem("userId")) || 0;

//   const { loans, loading: loanLoading, error: loanError } = useSelector(
//     (state) => state.loanReport
//   );
//   const { customers, loading: customerLoading, error: customerError } =
//     useSelector((state) => state.customerReport);
//   const { profile } = useSelector((state) => state.userProfile);

//   const [loan, setLoan] = useState(null);
//   const [customer, setCustomer] = useState(null);
//   const [company, setCompany] = useState(null);


//   const [branch, setBranch] = useState(null); // 

//   useEffect(() => {
//     const loadData = async () => {
//       try {
//         const loanAction = await dispatch(fetchAllLoans());
//         if (!fetchAllLoans.fulfilled.match(loanAction)) {
//           toast.error("Failed to fetch loan details");
//           return;
//         }
//         const loanList = loanAction.payload?.data || loanAction.payload || [];
//         const foundLoan = loanList.find((l) => String(l.id) === String(loanId));
//         if (!foundLoan) {
//           toast.error("Loan not found for this ID");
//           return;
//         }
//         setLoan(foundLoan);

//         const customerId = foundLoan.customerId || foundLoan.userId;
//         if (customerId) {
//           const customerAction = await dispatch(
//             fetchCustomers({ page: 1, limit: 1000 })
//           );
//           if (fetchCustomers.fulfilled.match(customerAction)) {
//             const customerList =
//               customerAction.payload?.data || customerAction.payload || [];
//             const foundCustomer = customerList.find(
//               (c) =>
//                 String(c.id) === String(customerId) ||
//                 String(c.userId) === String(customerId)
//             );
//             if (foundCustomer) setCustomer(foundCustomer);
//             else toast.warn("Customer not found for this loan");
//           } else {
//             toast.error("Failed to fetch customer details");
//           }
//         }

//         if (profile && profile.superAdminId) {
//           try {
//             const res = await fetch(
//               `https://payyug.in/api/get-company?superAdminId=${profile.superAdminId}`
//             );
//             if (!res.ok) throw new Error("Failed to fetch company info");
//             const data = await res.json();
//             const companyInfo = data.data || data;
//             if (companyInfo.logo) {
//               companyInfo.logoUrl = `https://payyug.in/${companyInfo.logo.replace(
//                 /^images\//,
//                 ""
//               )}`;
//             }
//             setCompany(companyInfo);
//           } catch (err) {
//             console.error("Failed to fetch company details:", err);
//           }
//         }





// if (profile.branchId) {
//           try {
//             const res = await fetch(
//               `https://payyug.in/api/get-byId/119`
//             );
//             if (!res.ok) throw new Error("Failed to fetch branch info");
//             const branchData = await res.json();
//             setBranch(branchData.data || branchData);
//           } catch (err) {
//             console.error("Failed to fetch branch details:", err);
//           }
//         }



        
//       } catch (err) {
//         console.error(err);
//         toast.error("Error fetching data");
//       }
//     };

//     loadData();
//   }, [dispatch, loanId, superAdminId, profile]);

//   const handleDownloadPDF = async () => {
//     const input = document.querySelector(".Sanc-letter-container");
//     const button = document.querySelector(".loan-application-print-button");
//     if (!input) return;

//     if (button) button.style.display = "none";

//     await new Promise((resolve) => {
//       const images = input.querySelectorAll("img");
//       let loaded = 0;
//       if (images.length === 0) resolve();
//       images.forEach((img) => {
//         if (img.complete) {
//           loaded++;
//           if (loaded === images.length) resolve();
//         } else {
//           img.onload = img.onerror = () => {
//             loaded++;
//             if (loaded === images.length) resolve();
//           };
//         }
//       });
//     });

//     const canvas = await html2canvas(input, {
//       scale: 2,
//       useCORS: true,
//       logging: false,
//     });
//     const imgData = canvas.toDataURL("image/png");
//     const pdf = new jsPDF("p", "mm", "a4");
//     const imgWidth = 210;
//     const pageHeight = 297;
//     const imgHeight = (canvas.height * imgWidth) / canvas.width;
//     let heightLeft = imgHeight;
//     let position = 0;

//     pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
//     heightLeft -= pageHeight;

//     while (heightLeft > 0) {
//       position = heightLeft - imgHeight;
//       pdf.addPage();
//       pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
//       heightLeft -= pageHeight;
//     }

//     pdf.save(`PromiseLetter_${loanId}.pdf`);

//     if (button) button.style.display = "block";
//   };

//   if (loanLoading || customerLoading) {
//     return (
//       <div className="Sanc-letter-container">
//         <p>Loading details...</p>
//       </div>
//     );
//   }

//   if (loanError || customerError) {
//     return (
//       <div className="Sanc-letter-container">
//         <p style={{ color: "red" }}>{loanError || customerError}</p>
//       </div>
//     );
//   }

//   if (!loan) {
//     return (
//       <div className="Sanc-letter-container">
//         <p>No loan data available.</p>
//       </div>
//     );
//   }

//   const customerData = customer || {};
//   const loanHolderName = customerData.fullName || loan.userName || "N/A";
//   const companyName = company?.name || "Company Name";

//   const street = (customerData.address || loan.address || "N/A").replace(
//     /\n/g,
//     ", "
//   );
//   const subDistrict = customerData.subDistrict || loan.subDistrict || "";
//   const district = customerData.district || loan.district || "N/A";
//   const state = customerData.state || loan.state || "N/A";
//   const pincode = customerData.pincode || loan.pincode || "N/A";
//   const fullAddress = `${street}${
//     subDistrict ? ", " + subDistrict : ""
//   }, ${district}, ${state} - ${pincode}`;
//    const placeAddress = branch
//     ? `${branch.address}, ${branch.city}, ${branch.state} - ${branch.country || ""}`
//     : "N/A";


//   return (
//     <div className="Sanc-letter-container">
//       <div className="Sancletter-header">
//         <div className="Sanclogo-box">
//           <img
//             src={company?.logoUrl || "/logo.png"}
//             alt="logo"
//             crossOrigin="anonymous"
//           />
//         </div>

//         <div className="Sanccompany-details Sanccompany-right-vertical">
//           <div>
//             <h2>{companyName}</h2>
//           </div>
//           <div>
//             <span>
//               <strong>CIN:</strong> {company?.cin || "N/A"}
//             </span>
//           </div>
//           <div>
//             <span>
//               <strong>Mobile No:</strong> {company?.contact || "N/A"}
//             </span>
//           </div>
//           <div>
//             <span>
//               <strong>Email ID:</strong>{" "}
//               {customerData.email || loan.email || company?.email || "N/A"}
//             </span>
//           </div>
//           <div>
//             <span>
//               <strong>Address:</strong> {company?.address || fullAddress}
//             </span>
//           </div>
//           <div>
//             <span>
//               <strong>Branch Name:</strong> {branch?.name || ""}
//             </span>
//           </div>
//         </div>
//       </div>
// <h3 className="title-center">DEMAND PROMISSORY NOTE</h3>
//         <div className="date-place">
//         <p><strong>Date:</strong> {loan.createdAt ? loan.createdAt.slice(0, 10) : "N/A"}</p>
//         <p><strong>Place:</strong> {placeAddress}</p>
//       </div>

      
//       <p>
//         <strong>{companyName}</strong> मैं श्री / श्रीमती{" "}
//         <strong>{loanHolderName}</strong> c/o निवासी{" "}
//         <strong>{fullAddress}</strong> का मूल निवासी हूँ,{" "}
//         <strong>{companyName}</strong> द्वारा मांगे जाने पर मेरे द्वारा प्राप्त की
//         गई ऋण राशि रुपए ₹ <strong>{loan.loanAmount || "N/A"}</strong> को मैं अपने
//         ऋण चुकौती की अनुसूची के अनुसार ईएमआई किस्तों का भुगतना करने का वादा करता
//         / करती हूं।
//       </p>

//       <p>
//         <br />
//         <strong>Amount : ₹ {loan.loanAmount || "N/A"}</strong>
//       </p>
//       <p>
//         This is to certify that I, <strong>{loanHolderName}</strong> C/O,
//         resident at <strong>{fullAddress}</strong> has taken a loan of amount{" "}
//         <strong>Rs. {loan.loanAmount || "N/A"}</strong> from{" "}
//         <strong>{companyName}</strong>. I hereby promise to pay the EMI
//         instalments as per the schedule of my loan repayment that was previously
//         checked and signed by me in the Loan Application Form.
//       </p>

//       <br />
//       <br />
    

//          <div className="stamp-box-section">
//         <div className="stamp-box">Affix ₹1 Revenue Stamp</div>
//       </div>

//       <table className="Promises-Signature-table">
//         <tbody>
//           <tr>
//             <td>
//               Member Signature <br /> (सदस्य के हस्ताक्षर)
//               <div style={{ height: "80px" }}></div>
//             </td>
//             <td>
//               Spouse Signature <br /> (जीवनसाथी के हस्ताक्षर)
//               <div style={{ height: "80px" }}></div>
//             </td>
//             <td>
//               Branch Seal With Signature <br /> (शाखा मोहर के साथ हस्ताक्षर)
//               <div style={{ height: "80px" }}></div>
//             </td>
//           </tr>
//         </tbody>
//       </table>

//       {/* ✅ Stamp Box Section */}
   

//       <div className="loan-application-print-button">
//         <button onClick={handleDownloadPDF}>Download PDF</button>
//       </div>
//     </div>
//   );
// };

// export default Promises;

/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import "./Promises.css";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchAllLoans } from "../../redux/slices/loan/loanReportSlice";
import { fetchCustomers } from "../../redux/slices/Customer/customerReportSlice";
import { toast } from "react-toastify";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";

const Promises = () => {
  const { loanId } = useParams();
  const dispatch = useDispatch();
  const superAdminId = Number(localStorage.getItem("userId")) || 0;

  const { loans, loading: loanLoading, error: loanError } = useSelector(
    (state) => state.loanReport
  );
  const { customers, loading: customerLoading, error: customerError } =
    useSelector((state) => state.customerReport);
  const { profile } = useSelector((state) => state.userProfile);

  const [loan, setLoan] = useState(null);
  const [customer, setCustomer] = useState(null);
  const [company, setCompany] = useState(null);
  const [branch, setBranch] = useState(null);

  useEffect(() => {
    const loadData = async () => {
      try {
        const loanAction = await dispatch(fetchAllLoans());
        if (!fetchAllLoans.fulfilled.match(loanAction)) {
          toast.error("Failed to fetch loan details");
          return;
        }
        const loanList = loanAction.payload?.data || loanAction.payload || [];
        const foundLoan = loanList.find((l) => String(l.id) === String(loanId));
        if (!foundLoan) {
          toast.error("Loan not found for this ID");
          return;
        }
        setLoan(foundLoan);

        const customerId = foundLoan.customerId || foundLoan.userId;
        if (customerId) {
          const customerAction = await dispatch(
            fetchCustomers({ page: 1, limit: 1000,superAdminId:profile.superAdminId })
          );
          if (fetchCustomers.fulfilled.match(customerAction)) {
            const customerList =
              customerAction.payload?.data || customerAction.payload || [];
            const foundCustomer = customerList.find(
              (c) =>
                String(c.id) === String(customerId) ||
                String(c.userId) === String(customerId)
            );
            if (foundCustomer) setCustomer(foundCustomer);
            else toast.warn("Customer not found for this loan");
          } else {
            toast.error("Failed to fetch customer details");
          }
        }

        if (profile && profile.superAdminId) {
          try {
            const res = await fetch(
              `https://payyug.in/api/get-company?superAdminId=${profile.superAdminId}`
            );
            if (!res.ok) throw new Error("Failed to fetch company info");
            const data = await res.json();
            const companyInfo = data.data || data;
            if (companyInfo.logo) {
              companyInfo.logoUrl = `https://payyug.in/${companyInfo.logo.replace(
                /^images\//,
                ""
              )}`;
            }
            setCompany(companyInfo);
          } catch (err) {
            console.error("Failed to fetch company details:", err);
          }
        }

        // ✅ Fetch Branch Info
        if (profile.branchId) {
          try {
            const res = await fetch(`https://payyug.in/api/get-byId/${profile.branchId}`);
            if (!res.ok) throw new Error("Failed to fetch branch info");
            const branchData = await res.json();
            console.log("branch data: ",branchData)
            setBranch(branchData.data || branchData);
          } catch (err) {
            console.error("Failed to fetch branch details:", err);
          }
        }
      } catch (err) {
        console.error(err);
        // toast.error(err?.response?.data?.message||"Error fetching data");
      }
    };

    loadData();
  }, [dispatch, loanId, superAdminId, profile]);

  // ✅ PDF Download
  const handleDownloadPDF = async () => {
    const input = document.querySelector(".Sanc-letter-container");
    const button = document.querySelector(".loan-application-print-button");
    if (!input) return;

    if (button) button.style.display = "none";

    await new Promise((resolve) => {
      const images = input.querySelectorAll("img");
      let loaded = 0;
      if (images.length === 0) resolve();
      images.forEach((img) => {
        if (img.complete) {
          loaded++;
          if (loaded === images.length) resolve();
        } else {
          img.onload = img.onerror = () => {
            loaded++;
            if (loaded === images.length) resolve();
          };
        }
      });
    });

    const canvas = await html2canvas(input, {
      scale: 2,
      useCORS: true,
      logging: false,
    });
    const imgData = canvas.toDataURL("image/png");
    const pdf = new jsPDF("p", "mm", "a4");
    const imgWidth = 210;
    const pageHeight = 297;
    const imgHeight = (canvas.height * imgWidth) / canvas.width;
    let heightLeft = imgHeight;
    let position = 0;

    pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
    heightLeft -= pageHeight;

    while (heightLeft > 0) {
      position = heightLeft - imgHeight;
      pdf.addPage();
      pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;
    }

    pdf.save(`PromiseLetter_${loanId}.pdf`);
    if (button) button.style.display = "block";
  };

  if (loanLoading || customerLoading) {
    return (
      <div className="Sanc-letter-container">
        <p>Loading details...</p>
      </div>
    );
  }

  if (loanError || customerError) {
    return (
      <div className="Sanc-letter-container">
        <p style={{ color: "red" }}>{loanError || customerError}</p>
      </div>
    );
  }

  if (!loan) {
    return (
      <div className="Sanc-letter-container">
        <p>No loan data available.</p>
      </div>
    );
  }

  // ✅ Data Formatting
  const customerData = customer || {};
  const loanHolderName = customerData.fullName || loan.userName || "N/A";
  const guardianName = customerData.guardianName || loan.guardianName || null;
  const companyName = company?.name || "Company Name";

  const street = (customerData.address || loan.address || "N/A").replace(/\n/g, ", ");
  const subDistrict = customerData.subDistrict || loan.subDistrict || "";
  const district = customerData.district || loan.district || "N/A";
  const state = customerData.state || loan.state || "N/A";
  const pincode = customerData.pincode || loan.pincode || "N/A";
  const fullAddress = `${district}, ${state} - ${pincode}`;
  const placeAddress = branch
    ? `${branch.address}, ${branch.city}, ${branch.state} - ${branch.country || ""}`
    : "N/A";

  return (
    <div className="Sanc-letter-container">
      {/* Header */}
      <div className="Sancletter-header">
        <div className="Sanclogo-box">
          <img
            src={company?.logoUrl || "/logo.png"}
            alt="logo"
            crossOrigin="anonymous"
          />
        </div>

        <div className="Sanccompany-details Sanccompany-right-vertical">
          <div><h2>{companyName}</h2></div>
          <div><span><strong>CIN:</strong> {company?.cin || "N/A"}</span></div>
          <div><span><strong>Regt. Office:</strong> {company?.address || "N/A"}</span></div>
          <div><span><strong>Branch Name:</strong> {branch?.name || "N/A"}</span></div>
          <div><span><strong>Mobile No:</strong> {company?.contact || "N/A"}</span></div>
          <div><span><strong>Email ID:</strong> {company?.email || "N/A"}</span></div>
        </div>
      </div>

      <h3 className="title-center">DEMAND PROMISSORY NOTE</h3>
      <div className="date-place">
        <p><strong>Date:</strong> {loan.createdAt ? new Date(loan.createdAt).toLocaleDateString("en-GB") : "N/A"}</p>
        <p><strong>Place:</strong> {placeAddress}</p>
      </div>

      {/* Hindi Section */}
      <p>
        <strong>{companyName}</strong> मैं श्री / श्रीमती{" "}
        <strong>{loanHolderName}</strong>
       
       
        {guardianName ? ` C/O   ${guardianName}` : ""  } निवासी{" "}
        <strong>{fullAddress}</strong> का मूल निवासी हूँ,{" "}
        <strong>{companyName}</strong> द्वारा मांगे जाने पर मेरे द्वारा प्राप्त की गई ऋण राशि रुपए ₹{" "}
        <strong>{loan.loanAmount || "N/A"}</strong> को मैं अपने ऋण चुकौती की अनुसूची के अनुसार
        ईएमआई किस्तों का भुगतना करने का वादा करता / करती हूं।
      </p>

      {/* English Section */}
      <p>
        This is to certify that I, <strong>{loanHolderName}</strong>
        {guardianName ? ` C/O ${guardianName}` : ""}, resident at{" "}
        <strong>{fullAddress}</strong> have taken a loan of amount{" "}
        <strong>Rs. {loan.loanAmount || "N/A"}</strong> from{" "}
        <strong>{companyName}</strong>. I hereby promise to pay the EMI instalments as per
        the schedule of my loan repayment that was previously checked and signed by me in the Loan Application Form.
      </p>

      <p>
        <strong>Amount: ₹ {loan.loanAmount || "N/A"}</strong>
      </p>

      {/* Stamp Box */}
      <div className="stamp-box-section">
        <div className="stamp-box">Affix ₹1 Revenue Stamp</div>
      </div>

      {/* Signature Table */}
      <table className="Promises-Signature-table">
        <tbody>
          <tr>
            <td>
              Member Signature <br /> (सदस्य के हस्ताक्षर)
              <div style={{ height: "80px" }}></div>
            </td>
            <td>
              Spouse Signature <br /> (जीवनसाथी के हस्ताक्षर)
              <div style={{ height: "80px" }}></div>
            </td>
            <td>
              Branch Seal With Signature <br /> (शाखा मोहर के साथ हस्ताक्षर)
              <div style={{ height: "80px" }}></div>
            </td>
          </tr>
        </tbody>
      </table>

      <div className="loan-application-print-button">
        <button onClick={handleDownloadPDF}>Download PDF</button>
      </div>
    </div>
  );
};

export default Promises;
